import { render, staticRenderFns } from "./personInfo.vue?vue&type=template&id=f6d62192&scoped=true&"
import script from "./personInfo.vue?vue&type=script&lang=js&"
export * from "./personInfo.vue?vue&type=script&lang=js&"
import style0 from "./personInfo.vue?vue&type=style&index=0&id=f6d62192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d62192",
  null
  
)

export default component.exports